var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSectionContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.15588V3.82595L12.3 10.322C12.114 10.426 11.886 10.426 11.7 10.322L0 3.82595V1.15588C0 0.520145 0.54 0 1.2 0H22.8C23.46 0 24 0.520145 24 1.15588Z",
    fill: "#062F53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 11.8608L24 5.6001V15.6255C24 16.2715 23.46 16.8001 22.8 16.8001H1.2C0.54 16.8001 0 16.2715 0 15.6255V5.6001L11.1 11.8608C11.376 12.0194 11.688 12.0957 12 12.0957C12.312 12.0957 12.624 12.0194 12.9 11.8608Z",
    fill: "#062F53"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSectionContact);
export default __webpack_public_path__ + "static/media/icon_section_contact.74efa192.svg";
export { ForwardRef as ReactComponent };